module.exports = __webpack_public_path__ + "img/15passenger_driving.4ec1828f.svg";